import customerApi from '../../components/apis/customerApi';
import customerArrayBufferApi from '../../components/apis/customerArrayBufferApi';

export function changePassword(values) {
  return customerApi
    .post('/api/customer/change-password', values)
    .then((res) => res.data);
}
export function getPaymentCards() {
  return customerApi
    .get('/api/customers/payment-cards')
    .then((res) => res.data);
}
export function deletePaymentCard(id) {
  return customerApi
    .delete(`/api/customers/payment-cards/${id}`)
    .then((res) => res.data);
}

export function addPaymentCard() {
  return customerApi
    .post('/api/customers/payment-cards')
    .then((res) => res.data);
}

export function getCustomerStatements(params) {
  return customerApi
    .get('/api/customer/booked-statements', { params })
    .then((res) => res.data);
}
export function getCurrentCustomer() {
  return customerApi.get('/api/customers/current').then((res) => res.data);
}
export function getCustomerChosenPassengers() {
  return customerApi.get('/api/chosen-passengers').then((res) => res.data);
}

export function deleteCustomerChosenPassengers(id) {
  return customerApi
    .delete(`/api/chosen-passengers/${id}`)
    .then((res) => res.data);
}

export function editPhysicalCustomer(values) {
  return customerApi
    .put('/api/customer/profile/physical', values)
    .then((res) => res.data);
}

export function editLegalCustomer(values) {
  return customerApi
    .put('/api/customer/profile/legal', values)
    .then((res) => res.data);
}

export function editSavedPassengerService(id, values) {
  return customerApi
    .put(`/api/chosen-passengers/${id}`, values)
    .then((res) => res.data);
}

export function addChosenPassengersService(values) {
  return customerApi
    .post('/api/chosen-passengers', values)
    .then((res) => res.data);
}

export function getCustomerStatementInvoice(id, guid) {
  return customerArrayBufferApi
    .get(`/api/customer/booked-statements/invoice/${id}/${guid}`)
    .then((res) => res.data);
}

export async function getCustomerPaymentCards() {
  return customerApi
    .get('/api/customer/payments/cards')
    .then((res) => res.data);
}

export async function deactivateAccountService() {
  return customerApi
    .post('/api/customer/profile/deactivate')
    .then((res) => res.data);
}
